import type { FC, ReactNode } from 'react';

import { Container, Lines } from './styles';

type BracketProps = {
    children: ReactNode;
};
const Bracket: FC<BracketProps> = ({ children }) => (
    <Container>
        {children}
        <Lines />
    </Container>
);

export default Bracket;
